import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles, TextField, Button } from "@material-ui/core";
import t from "../../../languages/pl";

const useStyles = theme => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    inputField: {
        width: 250,
        margin: theme.spacing(0.5)
    }
});

const UserDetails = ({classes, username, onSubmit}) => {
    const [value, setValue] = useState(username);

    useEffect(() => {
        setValue(username);
    }, [username]);

    return (
        <div className={classes.container}>
            <TextField
                className={classes.inputField}
                label={t.firstAndLastName}
                value={value === null ? '' : value}
                onChange={e => setValue(e.target.value)}
            />
            <Button
                variant="contained"
                color="primary"
                className={classes.inputField}
                onClick={() => onSubmit && onSubmit(value)}
            >
                {t.confirm}
            </Button>
        </div>
    );
};

UserDetails.propTypes = {
    classes: PropTypes.object,
    username: PropTypes.string,
    onSubmit: PropTypes.func
};

export default withStyles(useStyles)(UserDetails);
